__turbopack_context__.v({
  "countCell": "styles-module-scss-module__7tsYca__countCell",
  "tooltipName": "styles-module-scss-module__7tsYca__tooltipName",
});
